import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pencil",
  "use": "icon-pencil-usage",
  "viewBox": "160.5 0.5 287 287",
  "content": "<symbol viewBox=\"160.5 0.5 287 287\" id=\"icon-pencil\">\r\n<path d=\"M402.7,0.5c24.8,0,44.8,20.1,44.8,44.8c0,10.1-3.3,19.4-9,26.9l-17.9,17.9l-62.8-62.8l17.9-17.9\r\n\tC383.2,3.8,392.6,0.5,402.7,0.5z M178.4,206.8l-17.9,80.7l80.7-17.9l165.9-165.9l-62.8-62.8L178.4,206.8z M361.1,102.4L235.5,228\r\n\tL220,212.5L345.6,86.9L361.1,102.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/pencil.svg
// module id = wt25
// module chunks = 0